
import React from 'react';
import { TrendingUp, Users, DollarSign, ShieldCheck, Clock, Percent } from 'lucide-react';

const BenefitsSection: React.FC = () => {
  return (
    <section className="py-20 bg-primary-blue text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-4">Business Benefits</h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Our referral platform delivers measurable results that impact your bottom line. 
            Here's how businesses are growing with our solution.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-10">
          <div className="flex flex-col items-center text-center">
            <div className="bg-white/20 p-4 rounded-full mb-4">
              <TrendingUp className="h-10 w-10" />
            </div>
            <h3 className="text-xl font-bold mb-3">Accelerated Growth</h3>
            <p className="text-blue-100">
              Businesses using our platform report an average 35% increase in new customer acquisition 
              within the first six months. Referrals consistently outperform other marketing channels 
              in terms of conversion rates and customer lifetime value.
            </p>
          </div>
          
          <div className="flex flex-col items-center text-center">
            <div className="bg-white/20 p-4 rounded-full mb-4">
              <DollarSign className="h-10 w-10" />
            </div>
            <h3 className="text-xl font-bold mb-3">Lower Acquisition Costs</h3>
            <p className="text-blue-100">
              Reduce your customer acquisition costs by up to 60% compared to traditional advertising. 
              Our clients report an average ROI of 400% on their referral program investment.
            </p>
          </div>
          
          <div className="flex flex-col items-center text-center">
            <div className="bg-white/20 p-4 rounded-full mb-4">
              <Users className="h-10 w-10" />
            </div>
            <h3 className="text-xl font-bold mb-3">Higher Quality Customers</h3>
            <p className="text-blue-100">
              Referred customers have a 37% higher retention rate and 16% higher lifetime value 
              than customers acquired through other channels. They're also 4x more likely to refer 
              others to your business.
            </p>
          </div>
          
          <div className="flex flex-col items-center text-center">
            <div className="bg-white/20 p-4 rounded-full mb-4">
              <ShieldCheck className="h-10 w-10" />
            </div>
            <h3 className="text-xl font-bold mb-3">Enhanced Trust</h3>
            <p className="text-blue-100">
              92% of consumers trust recommendations from people they know. Our platform helps you 
              leverage this trust to build credibility and accelerate the sales cycle.
            </p>
          </div>
          
          <div className="flex flex-col items-center text-center">
            <div className="bg-white/20 p-4 rounded-full mb-4">
              <Clock className="h-10 w-10" />
            </div>
            <h3 className="text-xl font-bold mb-3">Time Savings</h3>
            <p className="text-blue-100">
              Our automated system saves businesses an average of 15 hours per week in manual referral 
              tracking and reward management. Spend less time on administration and more time growing 
              your business.
            </p>
          </div>
          
          <div className="flex flex-col items-center text-center">
            <div className="bg-white/20 p-4 rounded-full mb-4">
              <Percent className="h-10 w-10" />
            </div>
            <h3 className="text-xl font-bold mb-3">Higher Conversion Rates</h3>
            <p className="text-blue-100">
              Referred leads convert at a 30% higher rate than leads from other sources. 
              Our platform's tracking and analytics help you optimize your referral process 
              to further improve these conversion rates over time.
            </p>
          </div>
        </div>
        
        <div className="mt-16 text-center">
          <div className="bg-white/10 rounded-lg p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold mb-4">Success Story</h3>
            <blockquote className="text-lg italic mb-6">
              "After implementing the ReferMe platform, we saw a 42% increase in new customer sign-ups 
              within just 3 months. The ROI has been incredible, and the platform's ease of use has made 
              it a favorite tool among our marketing team."
            </blockquote>
            <div>
              <p className="font-semibold">Sarah Johnson</p>
              <p className="text-blue-200">Marketing Director, TechSolutions Inc.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
